<template>
  <div>
    <div class="input-field">
      <input
        v-model="model"
        @change="handleChange"
        v-on:keyup.enter="onSubmit"
        :maxlength="maxlength"
        :minlength="minlength"
        :type="type"
        :id="name"
        required
        :class="{ 'border-error': showError }"
      />
      <label :for="name">{{ labelName }}</label>
    </div>
    <div class="error-message" :class="{ active: showError }">{{ errorMessage }}</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      model: this.initValue ? `${this.initValue}` : null
    };
  },
  props: {
    initValue: {
      type: String
    },
    type: {
      type: String
    },
    name: {
      type: String
    },
    labelName: {
      type: String
    },
    maxlength: {
      type: String
    },
    minlength: {
      type: String
    },
    showError: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String
    }
  },
  methods: {
    handleChange($event) {
      this.$emit("onChange", $event.target.value);
    },
    onSubmit ($event) {
      this.$emit("onSubmit", $event);
    }
  },
  watch: {
    model (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit("onChange", newVal);
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.input-field {
  position: relative;
  width: 100%;
  height: 46px;
  line-height: 46px;
  // margin-bottom: 15px;

  label {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    color: #7a8189;
    padding: 0 12px;
    transition: 0.2s all;
    font-size: 14px;
    cursor: text;
  }
  input {
    width: 100%;
    height: 46px;
    border-radius: 4px;
    outline: 0;
    border: none;
    font-size: 14px;
    padding: 10px 12px 0 12px;
    background-color: #f2f2f2;
    color: #1a1a1a;
  }
  input.border-error {
    border: 1px solid #ff5252;
  }
  input:invalid {
    outline: 0;
  }
  input:focus ~ label,
  input:valid ~ label {
    font-size: 10px;
    top: -12px;
    color: #7a8189;
    height: 0px;
  }
}
.error-message {
  font-size: 12px;
  color: #ff5252;
  display: none;
}
.error-message.active {
  display: block;
}
</style>
<style lang="scss">
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
